export abstract class AuthProcessProvider {
  readonly applicationName: string;
  readonly langLocale: string;
  readonly language: string;
  readonly appVersion?: string;
}